import { render, staticRenderFns } from "./AIML.vue?vue&type=template&id=6c0f438e&"
import script from "./AIML.vue?vue&type=script&lang=ts&"
export * from "./AIML.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports